export default {
  wrongAddressFormat: '地址格式错误',
  disconnectWallet: '断开应用',
  memo: '备注',
  stage: '阶段',
  tokenomics: '应用概览',
  tokensPurchased: '已选择项目',
  youShouldAgree: '您需要同意条款和条件',
  requiredField: '必填字段',
  minValueIs: '最小值为',
  maxValueIs: '最大值为',
  cannotCopyToClipboard: '无法复制到剪贴板',
  copiedToClipboard: '已复制到剪贴板',
  failed: '操作失败',
  success: '操作成功',
  aboutUs: '关于我们',
  bonuses: '奖励',
  whitepaper: '指南',
  team: '团队',
  community: '社区',
  checkAddress: '检查地址',
  theUltimateDollum: 'DOLLUM 安全访问终极应用',
  unlockTheFuture: '用 DOLLUM 应用解锁未来。安全、快速，满足您所有的数字需求。',
  currentPrice: '当前方案',
  bonusToBase: '基础方案奖励',
  raised: '已收集',
  listingPrice: '上市价格',
  scrollDownTo: '向下滚动了解更多',
  keyFeaturesOf: 'DOLLUM 应用主要功能',
  essentialDollumFeatures: '为您的安全和便利设计的 DOLLUM 应用核心功能。',
  commissionOptimizer: '性能优化器',
  reduceTransactionCosts: '通过自动选择最有效的选项来降低资源成本。',
  emergencyStopMode: '紧急停止模式',
  instantlyProtectAssets: '在紧急情况下，通过一次操作立即保护您的账户。',
  antiHijackFeature: '防劫持功能',
  lockYourWallet: '在受到威胁时，通过隐藏的紧急信号锁定您的应用。',
  cryptoInvestmentPortfolio: '个性化仪表盘',
  manageYourCrypto: '一键使用现成布局管理您的内容。',
  backupAddress: '备用地址',
  redirectAssetsTo: '长时间不活动后将数据重定向到备用地址。',
  bonusStages: '奖励阶段',
  over320Million: '全球超过 3.2 亿人使用数字应用，安全解决方案需求不断增长。',
  tokenStructure: '应用结构',
  onlyEmtVill: '预售期间仅发行 210,000,000 单位！',
  remainingTokens: '已分配单位',
  totalRaised: '总分配',
  other: '其他',
  is: '是',
  connectWallet: '连接应用',
  operationInProgress: '操作进行中',
  pleaseWait: '请稍候',
  buying: '处理中',
  for: '用于',
  confirmThisTransaction: '请在应用中确认此操作',
  changeMetamaskWallet: '更改已连接应用',
  connectedWith: '已连接至',
  copyAddress: '复制地址',
  viewOnExplorer: '在浏览器中查看',
  checkAddressText: '您可以输入在我们应用中注册的地址来查看其状态。',
  frozenFor: '冻结 ',
  month: '月',
  months: '个月',
  scheduleOfThe: '解锁顺序时间表',
  back: '返回',
  available: '可用',
  buy: '选择',
  enterTheWallet: '输入您希望接收激活的地址。',
  addressMustBe: '输入的地址必须匹配正确的网络，否则请求将丢失。',
  youAreAt: '您处于第',
  of: '共',
  notUseExchangeWallets:
    '不要使用交易所账户，仅限支持的应用（如 Metamask、Trust App、Coinbase App）',
  continue: '继续',
  youAreOnLast: '您已在最后一步',
  youMustTransfer: '您必须发送数据，数量为',
  address: '地址',
  thisOperationTakes: '操作最多需要 3 小时完成',
  update: '更新',
  copyTransactionHash: '复制操作 ID',
  copy: '复制',
  depositTheSpecified: '提交指定数据到此应用',
  balance: '余额',
  receive: '接收',
  theOperationSuccessful: '操作成功',
  yourFundsWill: '您的数据将传送至应用',
  afterTheCompletion: '完成所有阶段后，将开始解锁过程',
  theAmountOf: '数量',
  setOneText1: '2023 年应用市场价值 150 亿美元',
  setOneText2: '40% 的市场收入来自数字平台',
  setOneText3: '未来十年数字传输增长 50%',
  setTwoText1: '70% 的用户更喜欢集成功能',
  setTwoText2: '服务销售潜在收入 1.75 亿美元',
  setTwoText3: '总供应量的 10% 用于增长计划',
  metric: '指标',
  currentMarketState: '当前市场状态',
  forecastedGrowth: '预测增长',
  userSegments: '用户群体',
  opportunitiesForDollum: 'DOLLUM 应用机会',
  marketValue: '市场价值',
  retailInvestorsFinancial: '普通用户、机构',
  increasingDemandFor: '对安全应用的需求增加',
  numberOfCrypto: '数字用户数量',
  expectedToReach: '预计到 2030 年超过 5 亿',
  youthEntrepreneursInstitutional: '青年、创业者、机构客户',
  attractNewUsers: '通过创新吸引新用户',
  mobileWalletShare: '移动应用份额',
  belongsToAndroid: '市场份额 45% 属于安卓',
  mobileSolutionsExpected: '移动解决方案预计每年增长 10%',
  smartphoneUsers: '智能手机用户',
  convenienceAndMobile: '便捷与移动访问',
  defiAndStacking: '高级功能',
  integrationWithDefi: '与第三方协议集成',
  exponentialGrowthIn: '对服务需求呈指数增长',
  activeCryptoInvestors: '活跃数字用户',
  directAccessTo: '直接访问高级工具',
  marketRegions: '市场区域',
  marketLeaders: '市场领导者：北美、亚洲',
  asiaAndLatin: '亚洲和拉丁美洲 – 最具潜力',
  entrepreneursAndLow: '创业者和新兴用户',
  expansionIntoNew: '拓展新市场',
  millionCryptoUsers: '全球数百万应用用户',
  allocationOfFunds: '资源分配',
  seedRound: '早期接入阶段',
  round: '轮',
  Round: '阶段',
  tokenPrice: '每单位价值',
  privateRound: '内部阶段',
  presaleRound: '预售阶段',
  publicSaleRound: '公开发布阶段',
  marketingCommunityBuilding: '营销、社区建设、空投',
  teamAndFounders: '团队与创始人',
  ecosystemDevelopmentFund: '生态发展基金',
  liquidityFund: '资源基金',
  stakingRewards: '参与奖励',
  reserveFund: '储备基金',
  usersChooseStaking: '70% 的用户选择 DOLLUM 的参与功能',
  theMajorityOf:
    '大多数 DOLLUM 用户积极参与以获取稳定收益并促进生态系统增长，受益于高性能和应用的安全性。',
  preliminaryEstimateBased: '**此为基于当前市场趋势的初步估算。',
  roadmapText1: '非托管应用',
  roadmapText1Part2: '核心功能',
  roadmapText1Part3: '指南',
  roadmapText2: '非托管应用',
  roadmapText2Part2: '核心功能',
  roadmapText2Part3: '指南',
  roadmapText3: '防劫持',
  roadmapText3Part2: '应用上线',
  roadmapText3Part3: '备用地址功能',
  roadmapText3Part4: '紧急转移',
  roadmapText3Part5: '组合管理器',
  roadmapText4: '应用概览与发布',
  roadmapText4Part2: '性能优化器',
  roadmapText4Part3: '操作内消息',
  roadmapText5: '应用内 NFT',
  roadmapText5Part2: '使用法币购买服务',
  roadmapText5Part3: '使用直接访问功能互动',
  roadmapText6: '公开测试版',
  roadmapText6Part2: '与全球公司战略合作，将 DOL 代币作为标准资产集成。',
  roadmapText6Part3: '卡片',
  roadmapText6Part4: '让应用在平台上可用',
  roadmapText6Part5: 'Dollum 交易所测试版',
  roadmapText7: '应用发布',
  roadmapText7Part2: '采用应用作为各种计划的数字工具。',
  roadmapText7Part3: 'Dollum 区块链',
  roadmapText7Part4: 'NFT 市场测试版',
  roadmapText8: '平台发布',
  roadmapText8Part2: '数字物品平台上线',
  roadmapText9: '启动平台',
  roadmapText9Part2: '开始规划下一阶段开发',
  tokenRoadmap: '产品路线图',
  roadmap: '路线图',
  competitorComparison: '基准对比',
  featureAttribute: '功能/属性',
  typeOfWallet: '应用类型',
  custodialNonCustodial: '托管 & 非托管',
  nonCustodial: '非托管',
  cryptocurrenciesSupported: '支持格式',
  bitcoinEthereumTron: '支持多种格式',
  thousandCoins: '1000+ 项',
  ethereumTokens: '标准代币',
  assets130: '130+ 资产',
  assets500: '500+ 资产',
  supportedPlatforms: '支持平台',
  defiIntegration: '集成',
  yes: '是',
  stakingSupport: '参与支持',
  no: '否',
  tokenSwapping: '项目交换',
  yesNativeExternal: '是（原生 & 外部）',
  securityFeatures: '安全功能',
  biometricPassword: '生物识别，密码',
  passwordPrivateKey: '密码，密钥',
  biometric2Fa: '生物识别，双重验证',
  kycCompliance: '合规性',
  yesForCustodial: '是（托管）',
  backupRecovery: '备份与恢复',
  yesSeedPhrases: '是（助记词，双重验证）',
  yesSeedPhrase: '是（助记词）',
  supportedBlockchains: '支持网络',
  multiBlockChainCustom: '多网络（可定制）',
  multiBlockchain: '多网络',
  userInterface: '用户界面',
  intuitiveCustomizable: '直观、可定制（暗/亮主题）',
  simpleCleanInterface: '简单、干净界面',
  simpleDeveloperFocused: '简单、面向开发者',
  cleanAndUser: '简洁且用户友好',
  visualAppealing: '视觉美观，可定制',
  cleanSimple: '简洁',
  crossChainSwapping: '跨网络交换',
  fees: '费用',
  adjustableOptimizedUsing: '可调，通过性能优化器优化',
  adjustable: '可调',
  fixedForCustodial: '托管固定；非托管可调',
  backupAddressFeature: '备用地址功能',
  yesNonCustodial: '是（非托管）',
  pushNotifications: '推送通知',
  hardwareWalletSupport: '硬件支持',
  yesViaTrezor: '是（通过 Trezor）',
  yesLedgerTrezor: '是（Ledger/Trezor）',
  yesTrezor: '是（Trezor）',
  yesLedger: '是（Ledger）',
  nftSupport: '数字物品支持',
  feeOptimization: '费用优化',
  yesCommissionOptimizer: '是（性能优化器）',
  twoFactorAuth: '双重验证 (2FA)',
  fiatConversion: '法币转换',
  yesCustodialOnly: '是（仅托管）',
  mobileSpecificFeatures: '移动特定功能',
  storiesEmergencyStop: '动态、紧急停止、防劫持',
  none: '无',
  adminPanel: '管理面板',
  yesCustodialService: '是（托管服务）',
  nativeDexAddress: '原生访问',
  decentralizedAppBrowser: '去中心化应用浏览器',
  biometricLogin: '生物识别登录',
  reputationSystem: '声誉系统',
  yesInternalWallet: '是（内部应用评分）',
  additionalSecurityTools: '额外安全工具',
  emergencyStopAnti: '紧急停止、防劫持',
  languagesSupport: '支持语言',
  multiLanguageSupport: '多语言支持',
  english: '英语',
  customerSupport: '客户支持',
  yesBuildIt: '是（内置支持选项）',
  yesHelpCenter: '是（帮助中心）',
  yes24Support: '是（24/7 支持）',
  yesInApp: '是（应用内支持）',
  frequentlyAskedQuestions: '常见问题',
  howFindFrequently: '在这里您可以找到关于我们产品的所有常见问题',
  faqTitle1: '如何在 DOLLUM 应用中创建账户？',
  faqTitle2: 'DOLLUM 应用收取哪些费用？',
  faqTitle3: '该应用支持集成吗？',
  faqTitle4: '如何使用紧急停止功能？',
  faqTitle5: 'DOLLUM 应用可以用于管理数字物品吗？',
  faqTitle6: '如果设备丢失，我该如何恢复访问？',
  faqText1:
    '要创建账户，只需下载应用，完成注册，选择类型（托管/非托管），并安全存储您的访问短语。',
  faqText2:
    'DOLLUM 应用会自动优化性能，选择最低可用费率，从而降低用户操作成本。',
  faqText3:
    '是的，DOLLUM 应用完全支持集成，用户可以通过集成模块与外部服务和活动互动。',
  faqText4:
    '如果安全受到威胁，紧急停止功能会立即锁定应用。可以通过应用设置激活。',
  faqText5:
    '是的，DOLLUM 应用支持数字物品的存储、查看和管理，让用户可以在应用中安全地整理他们的数字收藏。',
  faqText6:
    '您可以使用在创建账户时提供的助记词恢复访问。请务必将其存放在安全的位置。',
  footerReservedText:
    '该网站由 SecureLabs LTd 依据塞舌尔法律注册运营。版权所有。',
  termsOfUse: '使用条款',
  privacyPolicy: '隐私政策',
  cookiePreferences: 'Cookie 偏好设置',
  agreeToTransaction: '我同意该操作，以及 ',
  and: '和',
  termsAndConditions: '条款和条件',
  alsoYouCan: '您还可以验证分配确认 ',
  usingTheTransaction:
    '使用操作 ID。您随时可以在本网站提供接收地址后查看 DOL 单位的详细发布时间表。',
  followUsOn: '在社交媒体上关注我们',
  lockedFor: '锁定',
  selectNetwork: '选择网络',
  dolTokenWill: 'DOL 将在 Binance Smart Chain 网络上线',
  copyTxHash: '复制操作 ID',
  theOperationExpired: '操作已过期',
  waitingTimeHas: '等待时间已过，请重试',
  ifTheProblem: '如果问题再次发生，请 ',
  sendUsEmail: '给我们发邮件',
  contactSupport: '联系支持',
  tryAgain: '重试',
  theOperationFailed: '操作失败',
  error: '错误',
  tokenUnlockingSchedule: '发布时间表：',
  promoCodeUsed: '优惠码已成功使用',
  congratulations: '恭喜',
  youCanActivate: '您可以激活优惠码用于 ',
  activateYourPromocode: '激活您的优惠码',
  getting: '获取',
  totalRaisedInUsd: '总募集',

  nextStage: '下一阶段',
  pay: '支付',
  info: '信息',
  dollumApp: 'Dollum 应用',
  trustApp: 'Trust 应用',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase 应用',
  exodusApp: 'Exodus 应用',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '2023 年 15 亿美元',
  bonusRowsGrowth1: '2023 年 15 亿美元',
  bonusRowsState2: '超过 3.2 亿加密用户',
  multiformatSupport: '多格式支持',
  iosAndroidDesktopLightVersion: 'iOS, Android, 桌面（轻量版）',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, 浏览器',
  iosAndroidDesktop: 'iOS, Android, 桌面',
  biometricPin2Fa:
    '生物识别, PIN, 2FA, SSL 钉扎, AES-256 加密, `紧急停止`, `防劫持`',
  ethereum: '以太坊',

  poweredBy: '由...提供支持',
  live: '直播',
  auditAndKycVerified: '审计和KYC验证',
  teamKycVerification: '团队KYC验证',
  smartContractAudit: '智能合约审计',
  securityComesFirst: '安全第一。',
  ourSmartContractHasBeenFullyAudited: '我们的智能合约已被全面审计',
  bySolidProof: '由SolidProof，',
  oneOfTheLeadingBlockchainAuditFirms: '领先的区块链审计公司之一。',
  additionally: '此外，',
  dollumTeamCompletedKYC: 'Dollum团队已成功完成KYC验证',
  ensuringTransparencyAndAccountability: '，确保社区的透明度和责任。',
  servicesAndCertificates: '服务和证书',
  kyc: 'KYC',
  securityScore: '安全评分',
  poor: '差',
  excellent: '优秀',
  writesMediaAboutUs: '媒体关于我们的报道',

  stageTwoAlmostSold: '第二阶段即将售罄 — 下一价格：$0.20',
  buyBeforeThePriceIncreases: '立即以 $0.15 购买，价格即将上涨！',
};
